import { InjectionToken } from '@angular/core';
import { ApiConstant } from '../types';

export type ScoreOutcome = 'none' | 'accepted' | 'rejected';

export interface DirtyComponent {
    isDirty: boolean;
}

export interface CommonDirtyComponent {
    childComponent: DirtyComponent;
}

export interface AgencyInfo {
    id: string;
    name: string;
}

export interface BreadCrumbItem {
    name: string;
    path: string;
    context?: any;
}

export interface BreadcrumbAction {
    name: string;
    iconCls: string;
    actionFn: Function;
}

export interface StringValuePair {
    id: string;
    value: string;
}

export const REGION_API_TOKEN = new InjectionToken<ApiConstant>('api.constant');

export interface RegionGeographies {
    id: string;
    value: string;
    geographies: StringValuePair[];
}

export interface Login {
    response: {
        accessToken: string;
    };
}

export enum Role {
    SUPER_ADMIN = "SUPER_ADMIN",
    SIMU_ADMIN = "SIMU_ADMIN",
    ORG_ADMIN = "ORG_ADMIN",
}

export enum Languages {
    EN = 'en',
    HE = 'he',
}

export type UserAttrs = {
    sub: string,
    emailVerified: boolean,
    name: string,
    phoneNumber: string,
    givenName: string,
    role: Role,
    email: string,
    picture: string,
    organizationId?: number
}

export type CognitoUser = {
    username: string,
    email: string,
    name: string,
    givenName: string,
    phoneNumber: string,
    status: string,
    createdDate: string,
    lastModifiedDate: string
}


export class ExpireTokenException extends Error {
    constructor() {
        super('Token has expired. Please login again.');
    }
}

export class UnAuthorizedException extends Error {
    constructor() {
        super('Unauthorized. Please login again.');
    }
}
